export default __webpack_public_path__ + "media/images/default-person-f4acf5ba42b9424fe503484bdcc93552.png";